import { scanList } from '../contexts/FocusScanContext';
import * as theme from '../theme';

export default function FocusScansList() {

  const filteredScans = scanList
    .filter(scan => scan.label !== "No Preference")
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <div style={{ ...theme.Container.flexColumn, flex: 2, gap: 20, marginTop: 10 }}>
      {filteredScans.map((scan, index) => (
        <div key={index} style={{ padding: '0px 10px' }}>
          <div style={{ fontWeight: 'bold', fontSize: 16 }}>{scan.label}</div>
          <div style={{ marginTop: 5, fontSize: 14, paddingBottom: 15, borderBottom: '1px solid #ccc' }}>{scan.description}</div>
        </div>
      ))}
      <div style={{ padding: '0px 10px' }}>
        *If the scan requires an extra imprint remedy, the charge for this will be $20 on top of the normal scan cost. We will only do this if we feel it would be unsafe for the client otherwise.
      </div>
    </div>
  );
}